export interface TaskOwnerSource {
  compute?: {scope?: string | null} | null
  owner?: {id?: number | null; login?: string | null} | null
  creator?: {id?: number | null; login?: string | null} | null
}

export function resolveTaskOwnerLogin(
  task: TaskOwnerSource | null | undefined,
  fixedRepositoryOwner?: string | null,
): string | undefined {
  const computeScope = task?.compute?.scope?.trim()
  if (computeScope) return computeScope
  const ownerLogin = task?.owner?.login?.trim()
  if (ownerLogin) return ownerLogin

  const ownerId = task?.owner?.id
  const isPersonalOwner = ownerId === 0 || (typeof ownerId === 'number' && ownerId === task?.creator?.id)
  const personalOwnerLogin = isPersonalOwner ? task?.creator?.login?.trim() : undefined
  return personalOwnerLogin || fixedRepositoryOwner?.trim() || undefined
}
